<!-- 各栏目顶部标题 -->
<template lang="pug">
    div(:class="['header-title', isFixed ? 'header-title-fixed' : 'header-title-relative']")
        section.header-title-left
            slot(name="left")
                el-button.go-back-btn(
                    v-if="showBackBtn"
                    type="text"
                    icon="el-icon-arrow-left"
                    @click="goBackHandle"
                ) 返回
        section.header-title-center
            span {{ title }}
            span.desc
                slot(name="remark-desc")
        section.header-title-right
            slot
</template>
<script>
export default {
    name: 'HeaderTitle',
    props: {
        // 栏目标题
        title: {
            type: String,
            default: '默认标题',
        },
        // 是否展示返回按钮
        showBackBtn: {
            type: Boolean,
            default: true,
        },
        // 返回的路由名
        backRouteName: {
            type: String,
            default: '',
        },
        // 返回的路由配置
        backRouteOptions: {
            type: Object,
            default() {
                return {};
            },
        },
        // 是否固定顶部
        isFixed: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        goBackHandle() {
            if (!this.backRouteName) return;

            // 合并query参数
            const { navType } = this.$route.query;
            const backRouteOptions = {
                ...this.backRouteOptions,
                query: {
                    navType,
                    ...this.backRouteOptions.query,
                },
            };

            this.$router.push({
                name: this.backRouteName,
                ...backRouteOptions,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
    .header-title-fixed {
        position: fixed;
        top: 112px;
        left: 200px;
        right: 0;
        background-color: #fff;
    }
    .header-title-relative {
        position: relative;
    }
    .header-title {
        z-index: 99;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        padding: 0 20px;
        @include bg_color(color_base_white);
        &-center {
            position: absolute;
            width: calc(100% - 600px);
            top: 0;
            min-width: 240px;
            left: 300px;
            text-align: center;
            @include font_size(text_sub_emphasize);
            @include font_color(text_color_base);
            @include font_weight(text_font_weight);
            line-height: 50px;
            .desc {
                @include font-color(text_color_error);
            }
        }
        border-bottom-style: solid;
        border-bottom-width: 1px;
        @include border_color(color_base_background);
    }
    .go-back-btn {
        padding-left: 0 !important;
        padding-right: 0 !important;
        @include font_color(text_color_base, !important);
        &:hover {
            opacity: 0.7;
        }
        .el-icon-arrow-left {
            font-size: 60px;
        }
    }
</style>
<style lang="scss">
    .header-title {
        .go-back-btn {
            .el-icon-arrow-left {
                @include font_size(text_form_title);
            }
        }
    }
</style>
